import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiCardActions]',
    standalone: false
})
export class CardActionsDirective {
  @HostBinding('class') className = 'lui-card-actions';
}
